import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import Backdrop from 'components/Common/Backdrop/Backdrop';
import StudioSelectionSearchBar from 'components/Common/StudioSelectionSearchBar/StudioSelectionSearchBar';
import Layout from 'components/Layout/Layout';
import ProductSelectPopup from 'components/StudioSearchPage/StudioSearchResults/ProductSelectPopup/ProductSelectPopup';
import SearchCategoryText from 'components/StudioSearchPage/StudioSearchResults/SearchCategoryText/SearchCategoryText';
import SearchResultsGallery from 'components/StudioSearchPage/StudioSearchResults/SearchResultsGallery/SearchResultsGallery';
import Usps from 'components/StudioSearchPage/StudioSearchResults/Usps/Usps';
import useActiveRouteParameter from 'hooks/useActiveRouteParameter';
import useLocalStudioRecentlyViewed from 'hooks/useLocalStudioRecentlyViewed';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import fetchStudioSearchCategoryDataOperation from 'store/studioSearch/operation/fetchStudioSearchCategoryDataOperation';
import getRecentlyViewedItems from 'store/studioSearch/selector/getRecentlyViewedItems';
import { GettyImagesImageSearchResponseImage } from 'store/studioSearch/types';
import styles from './StudioSearchPage.module.scss';

const StudioSearchRecent = () => {
  const [items, setItems] = useState<GettyImagesImageSearchResponseImage[]>([]);
  const recentlyViewedItems = useSelector(getRecentlyViewedItems);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const categoryId = useActiveRouteParameter('categoryId', '');

  useLocalStudioRecentlyViewed();

  useEffect(() => {
    const ids = recentlyViewedItems?.map((item) => item.id);

    if (ids.length) {
      apiRequest<GettyImagesImageSearchResponseImage[]>(
        endpoints.gettyImagesV1Get,
        { ids, fields: ['detail_set', 'display_set'] },
        HttpMethods.POST,
        'data.images',
      ).then((res) => {
        setItems(res);
      });
    }
  }, [recentlyViewedItems]);

  useEffect(() => {
    dispatch(fetchStudioSearchCategoryDataOperation());
  }, []);

  return (
    <Layout>
      <StudioSelectionSearchBar
        categoryId={Number(categoryId)}
        className={styles.searchBar}
        isShownRecentlyViewed={false}
      />
      <h2 className={styles.title}>{t('txt_recently_viewed_items')}</h2>
      <SearchResultsGallery className={styles.gallery} isLoading={false} items={items} shouldStoreRecent={false} />
      <SearchCategoryText />
      <Usps />
      <Backdrop />
      <ProductSelectPopup />
    </Layout>
  );
};

export default StudioSearchRecent;
